import Vue from 'vue'       
import MarqueeText from 'vue-marquee-text-component'
import TitleTab from '@/components/Titletab.vue'
import DialogFormat from '@/components/Dialog/DialogFormat.vue'
import TextFieldSpecificString from '@/components/TextField/TextFieldSpecificString.vue'
import TextFieldFreeString from '@/components/TextField/TextFieldFreeString.vue'
import TextFieldNoSpace from '@/components/TextField/TextFieldNoSpace.vue'
import TextFieldSpecificStringFilterEmoji from '@/components/TextField/TextFieldSpecificStringFilterEmoji.vue'
import TextFieldSpecificUsername from '@/components/TextField/TextFieldSpecificUsername.vue'
import SelectBankType from '@/components/SelectField/SelectBankType.vue'
import SelectGameType from '@/components/SelectField/SelectGameType.vue'
import SelectNumberTemplateType from '@/components/SelectField/SelectNumberTemplateType.vue'
import TextFieldSpecificNumber from '@/components/TextField/TextFieldSpecificNumber.vue'
import Loading from '@/components/Loading.vue'
import Pagination from '@/components/Pagination.vue'
import Empty from '@/components/Empty.vue'
import DatePickerRange from '@/components/DatePickerRange.vue'
import CardVoucher from '@/components/Card/CardVoucher.vue'
import CardPullPole from '@/components/Card/cardPullPole.vue'
import OneColumnCard from '@/components/Card/oneColumnCard.vue'
import TwoColumnCard from '@/components/Card/twoColumnCard.vue'
import ThreeColumnCard from '@/components/Card/threeColumnCard.vue'
import ThreePlusColumnCard from '@/components/Card/threePlusColumnCard.vue'
import FourColumnCard from '@/components/Card/fourColumnCard.vue'
import FiveColumnCard from '@/components/Card/fiveColumnCard.vue'
import TwoColumnIndex from '@/components/Card/twoColumnIndex.vue'
import TwoColumnYeekeeCard from '@/components/Card/twoColumnYeekeeCard.vue'
import DataTableWithCardResult from '@/components/DataTable/DataTableWithCardResult.vue'
import DialogFormatV2 from '@/components/Dialog/DialogFormatV2.vue'
import CardReportV2 from '@/components/Card/CardReportV2.vue'
import ButtonSubmit from '@/components/Button/ButtonSubmit.vue'
import ButtonRound from '@/components/Button/ButtonRound.vue'
import ButtonRoundOutline from '@/components/Button/ButtonRoundOutline.vue'
import ButtonSubmitv2 from '@/components/Button/ButtonSubmit-v2.vue'
import Buttonv2 from '@/components/Button/Button-v2.vue'
import ButtonToggleCheckIcon from '@/components/Button/ButtonToggleCheckIcon.vue'
import CardRoundHeader from '@/components/Card/CardRoundHeader.vue'

const globalComponent = [
  {
    name: 'marquee-text',
    component: MarqueeText
  }, 
  {
    name: 'title-tab',
    component: TitleTab,
  },  
  {
    name: 'n-dialog',
    component: DialogFormat,
  },
  {
    name: 'n-text-field-specific',
    component: TextFieldSpecificString,
  },
  {
    name: 'n-text-field-free',
    component: TextFieldFreeString,
  }, 
  {
    name: 'n-text-field-no-space',
    component: TextFieldNoSpace,
  }, 
  {
    name: 'n-text-field-noemoji',
    component: TextFieldSpecificStringFilterEmoji,
  }, 
  {
    name: 'n-text-field-username',
    component: TextFieldSpecificUsername,
  },     
  {
    name: 'n-select-bank-type',
    component: SelectBankType,
  }, 
  {
    name: 'n-select-game-type',
    component: SelectGameType,
  }, 
  {
    name: 'n-select-numbertemplate-type',
    component: SelectNumberTemplateType,
  }, 
  {
    name: 'n-number-field-specific',
    component: TextFieldSpecificNumber,
  },  
  {
    name: 'loading-status',
    component: Loading,
  },  
  {
    name: 'n-pagination',
    component: Pagination,
  },
  {
    name: 'n-empty',
    component: Empty,
  },
  {
    name: 'n-datepicker-range',
    component: DatePickerRange,
  },   
  
  {
    name: 'n-card-voucher',
    component: CardVoucher,
  },
  {
    name: 'pullpole-card',
    component: CardPullPole,
  }, 
  
  {
    name: 'one-column-card',
    component: OneColumnCard,
  },
  {
    name: 'two-column-card',
    component: TwoColumnCard,
  },
  {
    name: 'three-column-card',
    component: ThreeColumnCard,
  },
  {
    name: 'three-plus-column-card',
    component: ThreePlusColumnCard,
  },
  {
    name: 'four-column-card',
    component: FourColumnCard,
  },
  {
    name: 'five-column-card',
    component: FiveColumnCard,
  },
  {
    name: 'index-two-column-card',
    component: TwoColumnIndex,
  },
  {
    name : 'two-column-yeekee-card',
    component: TwoColumnYeekeeCard,
  },

  // v2 
  {
    name : 'n-data-table-card-result',
    component: DataTableWithCardResult,
  }, 
  {
    name : 'nt-dialog',
    component: DialogFormatV2,
  }, 
  {
    name: 'n-card-reporter',
    component: CardReportV2,
  },
  {
    name : 'n-btn-submit',
    component: ButtonSubmit,
  },
  {
    name : 'n-btn-round',
    component: ButtonRound,
  },
  {
    name : 'n-btn-outlined',
    component: ButtonRoundOutline,
  },
  {
    name : 'n2-btn-submit',
    component: ButtonSubmitv2,
  },
  {
    name : 'n2-btn',
    component: Buttonv2,
  },
  {
    name : 'n-btn-toggle-check',
    component: ButtonToggleCheckIcon,
  }, 
  {
    name : 'n-card-round-header',
    component: CardRoundHeader,
  }, 
  
  
] 
globalComponent.map(item => (Vue.component(item.name, item.component)))

